import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

type NoDataProps = {
  text?: string;
};

export const NoData = ({ text }: NoDataProps) => {
  const { t } = useTranslation();

  return <Typography color="text.secondary">{text ?? t("noData")}</Typography>;
};
